<template>
  <div
    v-if="fabType === 'reservation'"
    class="d-flex flex-column"
    style="z-index: 100000;"
  >
    <v-speed-dial
      v-if="!isTouchDevice && isSameDay"
      v-model="fab"
      bottom
      right
      fixed
      open-on-hover
    >
      <template #activator>
        <v-btn
          class="white--text"
          fab
          color="brand"
          :disabled="!isLoaded"
          @click="newReservation(false)"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-btn
        v-if="isSameDay"
        class="white--text"
        fab
        small
        color="green"
        :disabled="!isLoaded"
        @click="newReservation(true)"
      >
        <v-icon>$vuetify.icons.walk-outline</v-icon>
      </v-btn>
    </v-speed-dial>
    <template v-else>
      <v-btn
        v-if="isSameDay"
        style="right: 28px; bottom: 88px;"
        fixed
        fab
        bottom
        right
        x-small
        class="white--text green"
        :disabled="!isLoaded"
        @click="newReservation(true)"
      >
        <v-icon>$vuetify.icons.walk-outline</v-icon>
      </v-btn>
      <v-btn
        class="white--text"
        fixed
        fab
        bottom
        right
        color="brand"
        :disabled="!isLoaded"
        @click="newReservation(false)"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
  </div>

  <v-btn
    v-else-if="inlineHelpAllowed && fabType === 'help'"
    class="white--text"
    fixed
    fab
    bottom
    right
    color="grey"
    @click="$emit('help')"
  >
    <v-icon>mdi-help</v-icon>
  </v-btn>
</template>

<script setup lang="ts">

import { isDateSameIgnoringTime } from '@/services/time-utils';
import store from '@/store/store';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router/composables';

const router = useRouter();
const inlineHelpAllowed = import.meta.env.VITE_INLINE_DOCS === 'true';

const props = defineProps({ fabType: { type: String, required: true } });
const emit = defineEmits(['new-walkin', 'new-reservation', 'help']);

const fab = ref(false);

const isTouchDevice = window.matchMedia('(pointer: coarse)').matches;

const isLoaded = computed(() => store.getters.isLoaded);
const isSameDay = computed(() => isDateSameIgnoringTime(new Date(), store.state.update.date));

const newReservation = (walkin: boolean) => {
  // if newReservation is invoked on other screen than Guests or Tables
  // push the Guests screen to router
  // & if date is different than today, adjust to today.
  if (router.currentRoute.meta?.fab !== 'reservation') {
    if (!isSameDay.value) {
      store.dispatch('changeToDate', new Date());
    }
    router.push('/guests');
  }
  if (walkin) { emit('new-walkin'); } else { emit('new-reservation'); }
};
</script>
